
import AngleManager from "../../AngleManager";
import PointManager from "../../PointManager";
import MoveAngle from "../../../animations/MoveAngleAnimation";
import ReduceOpacityAnim from "../../../animations/ReduceOpacityAnimation";
import calculateAngles from "../../../../../../src/utils/calculateAngles";
import { Coord } from "../../../../../../src/types/Interface";


export async function drawMoveAngles(circle, PointManager: PointManager, AngleManager: AngleManager): Promise<void> {
  const radians = PointManager.getInitialRadians();
  const points = PointManager.getRedPoints()
  const angles = calculateAngles(points[2], points[0], points[1]);

  AngleManager.cloneCircumAngles.forEach(angle => {
    drawCloneAngle(angle, { coord: points[2], startRadian: angles.startRadian, endRadian: angles.endRadian });
  })
  return new Promise((res) => {
    new MoveAngle(AngleManager.cloneCircumAngles[0], { x: circle.x, y: circle.y }, radians[0], Math.PI / 2, drawCloneAngle, () => {
      new MoveAngle(AngleManager.cloneCircumAngles[1], { x: circle.x, y: circle.y }, Math.PI / 2, radians[1], drawCloneAngle, () => {
        return AngleManager.cloneCircumAngles.forEach((cAngle, cAI) => {
          new ReduceOpacityAnim(cAngle, () => {
            if (cAI == 1) {
              return res();
            }
          }, 1000)
          new ReduceOpacityAnim(cAngle.AngleValue, () => { }, 1000)
        })
      });
    })
  })
}


function drawCloneAngle(angle, Detail: { coord: Coord, startRadian: number, endRadian: number }) {
  const { coord, startRadian, endRadian } = Detail;
  angle.draw(coord, startRadian, endRadian, 50, false);
  angle.AngleValue.setValue("x");
  angle.x = coord.x;
  angle.y = coord.y;
}